import PropTypes from 'prop-types';

import DataDictionaryView from './DataDictionaryView';
import ValidationRulesView from './ValidationRulesView';
import RenderHintsView from './RenderHintsView';

/**
 * Composes the 3 read-only per-field sections into a single expandable panel.
 * Empty-when-nothing-to-show: if all three children render null, the panel
 * renders a single hint line so the chevron still feels meaningful.
 */
export default function FieldDetailsPanel({ field, conditionalRuleIndices }) {
	const fieldId = field.fieldId || field.dataElementName;

	const dataDict = <DataDictionaryView field={field} fieldId={fieldId} />;
	const validation = <ValidationRulesView field={field} fieldId={fieldId} />;
	const renderer = <RenderHintsView field={field} fieldId={fieldId} />;

	const anyContent = !!(dataDict || validation || renderer);

	return (
		<div
			className="dsv-view__field-details"
			data-testid={`dsv-view-field-details-${fieldId}`}
			style={panelStyle}
		>
			{Array.isArray(conditionalRuleIndices) && conditionalRuleIndices.length > 0 && (
				<div style={badgeRowStyle}>
					<span style={badgeStyle} data-testid={`dsv-view-field-conditional-${fieldId}`}>
						Conditional — referenced in Rule {conditionalRuleIndices.map((n) => n + 1).join(', Rule ')}
					</span>
				</div>
			)}
			{dataDict}
			{validation}
			{renderer}
			{!anyContent && (
				<p style={emptyHintStyle}>
					No data dictionary, validation rules, or renderer hints recorded for this field.
				</p>
			)}
		</div>
	);
}

FieldDetailsPanel.propTypes = {
	field: PropTypes.object.isRequired,
	conditionalRuleIndices: PropTypes.arrayOf(PropTypes.number),
};

const panelStyle = {
	background: '#fafbfc',
	border: '1px solid #e5e7eb',
	padding: '12px 16px',
	margin: '0 0 8px 28px',
	borderRadius: '6px',
};

const badgeRowStyle = { marginBottom: '8px' };

const badgeStyle = {
	display: 'inline-block',
	background: '#fef3c7',
	color: '#92400e',
	fontSize: '11px',
	fontWeight: 600,
	padding: '2px 8px',
	borderRadius: '10px',
	letterSpacing: '0.02em',
};

const emptyHintStyle = {
	fontSize: '12px',
	color: '#9ca3af',
	fontStyle: 'italic',
	margin: 0,
};
